import { makeObservable, observable, flow, computed, action } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import BrowseRiskWatchlistSchema from "@/areas/risks/schemas/BrowseRiskWatchlistSchema";

export default class BrowseRiskWatchlistStore {
  loading = true;
  pagination = null;
  watchlistRisks = [];

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      pagination: observable,
      watchlistRisks: observable,
      actions: computed,
      consume: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }
  get processing() {
    return this.loading;
  }

  get actions() {
    const list = [];

    return list;
  }

  consume(watchlistRisk) {
    const index = this.watchlistRisks.findIndex((e) => e.id === watchlistRisk.id);
    if (index !== -1) {
      this.watchlistRisks.splice(index, 1, watchlistRisk);
      this.watchlistRisks = [...this.watchlistRisks];
    }
  }

  *load(query, options) {
    const parseResult = BrowseRiskWatchlistSchema.safeParse(query);
    if (!parseResult.success) {
      console.error(parseResult.error);
      return parseResult;
    }

    try {
      this.loading = true;

      const response = yield api.post(ApiRoutes.forRiskSearch(), {
        ...query,
        query: { ...query.query, inWatchlist: true },
      });
      this.watchlistRisks = response.data.items;
      this.pagination = {
        page: response.data.page,
        totalItems: response.data.totalItems,
        totalPages: response.data.totalPages,
        pageSize: response.data.pageSize,
      };
      return { success: true, data: response.data };
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
